export type TDaysOfTheWeek = {
  [index: string]: string;
};

export const daysOfTheWeek: TDaysOfTheWeek = {
  '1': 'Mo',
  '2': 'Tu',
  '3': 'We',
  '4': 'Th',
  '5': 'Fr',
  '6': 'Sa',
  '7': 'Su',
};
